import axios from 'axios'

const ENDPOINT = 'location'

export default {
  delete: async (sitePath, id) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    const response = await axios.get(url)

    return response.data
  },

  getAll: async sitePath => {
    const url = `${sitePath}/${ENDPOINT}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/${ENDPOINT}/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    const response = await axios.put(url, data)

    return response.data
  },
}
